import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";

const collections = [
  { key: "print", image: "/images/print-category.jpg" },
  { key: "original", image: "/images/original-category.jpg" },
] as const;

export default function Home() {
  const { t } = useI18n();

  return (
    <div className="minimal-home">
      <section className="minimal-hero">
        <img
          src="/images/hero-artwork-cropped.jpg"
          alt="Floral painting with two birds"
          className="minimal-hero-image"
        />
        <div className="hero-signature" aria-label="Dalila Di Maria">
          <img
            src="/images/logo-dm-dalila.svg"
            alt="Dalila Di Maria"
            className="hero-signature-logo"
          />
        </div>
        <div className="minimal-hero-copy">
          <p>{t.home.heroSubtitle}</p>
          <Link to="/gallery" className="minimal-link">
            {t.home.heroCta}
            <ArrowRight size={15} />
          </Link>
        </div>
      </section>

      <section className="minimal-collections">
        <div className="minimal-section-title">
          <span>{t.home.categoriesTitle}</span>
          <Link to="/gallery">{t.home.viewAll}</Link>
        </div>

        <div className="minimal-collection-grid">
          {collections.map((collection) => (
            <Link
              key={collection.key}
              to={`/gallery/${collection.key}`}
              className="minimal-collection-card"
            >
              <div className="minimal-collection-image">
                <img src={collection.image} alt={t.categories[collection.key]} />
              </div>
              <div className="minimal-collection-meta">
                <h2>{t.categories[collection.key]}</h2>
                <span>{t.categories[`${collection.key}Desc`]}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
